<div class="ss_view-part"
     (click)="toggleDropdown(searchInput)"
     [ngClass]="{'p-n': noPadding, 'dropup': dropup}"
     [class.disabled]="!data.length">
    <span>{{selectedText}}</span>

    <i class="label-icon mtv-primary-color {{labelClass}}" aria-hidden="true" [hidden]="!selectedText || !selectedItemCondition"></i>
    <i class="label-icon {{labelNotMatchClass}}" aria-hidden="true" [hidden]="!selectedText || selectedItemCondition"></i>
</div>

<div class="ss_dropdown" [class.dropup]="dropup" [hidden]="!showDropdown">
    <input class="ss_search-input" [(ngModel)]="searchStr" (ngModelChange)="filteredData()" #searchInput
           (keydown.ArrowUp)="onKeydownArrowUp()"
           (keydown.ArrowDown)="onKeydownArrowDown()"
           (keydown.enter)="onKeydownEnter($event)">
    <ul>
        <li *ngFor="let item of filteredDataArray; let i = index;"
            (click)="select()"
            (mouseenter)="focusIndex = i"
            [ngClass]="{'focus': i == focusIndex}">
            {{item.optionText}}
            <i class="label-icon mtv-primary-color {{labelClass}}"
               aria-hidden="true"
               [title]="labelPopoverText"
               [hidden]="!item[labelCondition]">
            </i>
            <i class="label-icon {{labelNotMatchClass}}"
               aria-hidden="true"
               [title]="negativeLabelPopoverText"
               [hidden]="item[labelCondition]">
            </i>
        </li>
        <li *ngIf="filteredDataArray.length === 0">No results match "{{searchStr}}"</li>
    </ul>
</div>

<div class="ss_arrow"
     [class.dropup]="dropup"
     (click)="toggleDropdown(searchInput)"
     [ngStyle]="{'z-index' : showDropdown ? '9999' : '1000'}">
</div>



// WEBPACK FOOTER //
// /app/src/app/components/search-select-with-label/search-select-with-label.component.html